import { get } from 'lodash/fp';
import convertDesignToJob from '../../api/mandi/convertDesignToJob';

export default (cartingOptions) => {
  const designId = get('designId', cartingOptions);
  const leafItems = get('leafItems', cartingOptions);
  const extraAttributes = get('options.createAndSaveJob', cartingOptions);

  return convertDesignToJob(designId, leafItems, extraAttributes, { mode: 'persistent' })
    .then(job => ({
      ...cartingOptions,
      job,
    }));
};

